// Wind Speed(Kts)
// Classification

const directions = [{
        label: "N",
        centerDirection: 0,
    },
    {
        label: "N",
        centerDirection: 360,
    },
    {
        label: "NNE",
        centerDirection: 22.5,
    },
    {
        label: "NE",
        centerDirection: 45,
    },
    {
        label: "ENE",
        centerDirection: 67.5,
    },
    {
        label: "E",
        centerDirection: 90,
    },
    {
        label: "ESE",
        centerDirection: 112.5,
    },
    {
        label: "SE",
        centerDirection: 135,
    },
    {
        label: "SSE",
        centerDirection: 157.5,
    },
    {
        label: "S",
        centerDirection: 180,
    },
    {
        label: "SSW",
        centerDirection: 202.5,
    },
    {
        label: "SW",
        centerDirection: 225,
    },
    {
        label: "WSW",
        centerDirection: 247.5,
    },
    {
        label: "W",
        centerDirection: 270,
    },
    {
        label: "WNW",
        centerDirection: 292.5,
    },
    {
        label: "NW",
        centerDirection: 315,
    },
    {
        label: "NNW",
        centerDirection: 337.5,
    },
];

const halfInterval = 22.5 / 2

function findCardinalDirection(qDirection) {
    let ret = ""
    for (let ii = 0; ii < directions.length; ii++) {
        if (Math.abs(directions[ii].centerDirection - qDirection) < halfInterval) {
            ret = directions[ii].label
            break
        }
    }

    return ret;
}

export default findCardinalDirection;